// Officer identity helpers, shared by the shell, the router and the section gate.

export const DEO = "District Education Officer";
export const BEO = "Block Education Officer";

/**
 * Designations that sign in through e-Shiksha SSO. They get the officer shell
 * instead of the call-centre NavbarMenu + sidebar.
 */
export const OFFICER_DESIGNATIONS = [
    BEO, DEO,
    "State Project Director", "Additional State Project Director, Bihar",
    "Additional State Project Director- Programme", "Director, Secondary",
    "Director, Primary", "Director, MDM", "Director, Administration",
    "Director, SCERT", "Dy. Director, Education",
    "Assistant Director, Education",
    "Additional State Project Director - Academic", "DRT",
];

export const isOfficer = (auth) => OFFICER_DESIGNATIONS.includes(auth?.vchDesignationName);

/** Where "Home" goes for each officer level — the same page SSO login lands on. */
export const officerHomePath = (auth) => {
    if (auth?.vchDesignationName === DEO) return "/pendency-officer?type=DISTRICT&code=0&category=all&assigned=all";
    if (auth?.vchDesignationName === BEO) return "/officer/dash";
    return "/pendency-officer?type=STATE&code=0&category=all&assigned=all";
};
